module.exports = __webpack_public_path__ + "assets/img/75@3x.50813cb4.png";